/* Deliberate loosely-typed web stub mirroring the native PlayerService. */
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface PlayerServiceInterface {
  pauseTime: number | null;
  shouldResumeRadioAfterPodcast: boolean;
  setup: () => Promise<void>;
  addStream: (stream: string, startAfterAdd?: boolean) => Promise<void>;
  addPodcastEpisode: (episode: any, startPosition?: number) => Promise<void>;
  play: () => Promise<void>;
  pause: () => Promise<void>;
  stop: () => Promise<void>;
  skipToNext: () => Promise<void>;
  skipToPrevious: () => Promise<void>;
  reset: () => Promise<void>;
  seekTo: (value: number) => Promise<void>;
  setRate: (value: number) => Promise<void>;
  getIsPlaying: () => Promise<boolean>;
  remove(tracks: number | number[]): Promise<void>;
  resetQueue(): Promise<void>;
  getQueue: () => Promise<any[]>;
  getProgress: () => Promise<any>;
  getCurrentTrack: () => Promise<any>;
  setOptionsForStream: () => Promise<void>;
  registerPlaybackService(factory: () => () => Promise<void>): void;
  updateNowPlayingMetadata: (metadata: any) => Promise<void>;
  updateMetadataForTrack(trackIndex: number, metadata: any): Promise<void>;
  updateOptions: (options?: any) => Promise<void>;
  setVolume: (level: number) => Promise<void>;
  getVolume: () => Promise<number>;
  getPlaybackState: () => Promise<any>;
  setPause: (time: number | null) => void;
  setCurrentTrack: (
    title: string,
    artist: string,
    artwork: string | any,
  ) => Promise<void>;
  skipBackward: (seconds: number) => Promise<void>;
  skipForward: (seconds: number) => Promise<void>;
  getIsLiveStream(): Promise<boolean>;
}
const nullFunction = async () => Promise.resolve();
export const PlayerService: PlayerServiceInterface = {
  pauseTime: null,
  shouldResumeRadioAfterPodcast: false,
  skipToNext: nullFunction,
  skipToPrevious: nullFunction,
  reset: nullFunction,
  play: nullFunction,
  stop: nullFunction,
  seekTo: nullFunction,
  setRate: nullFunction,
  getQueue: nullFunction,
  getProgress: nullFunction,
  remove: nullFunction,
  resetQueue: nullFunction,
  registerPlaybackService: nullFunction,
  updateNowPlayingMetadata: nullFunction,
  updateMetadataForTrack: nullFunction,
  updateOptions: nullFunction,
  setVolume: nullFunction,
  getVolume: nullFunction,
  getPlaybackState: nullFunction,
};
